module.exports = __webpack_public_path__ + "img/works_subway_mobile_app_1.ed69d049.png";